export default __webpack_public_path__ + "images/info_a9cf2e.svg";